// avstemming-assets-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'avce.common.amount': 'Beløp',
  'avce.common.date': 'Dato',
  'avce.common.type': 'Type',
  'avce.common.account': 'Konto',
  'avce.common.status': 'Status',
  'avce.common.difference': 'Differanse',
  'avce.common.none': 'Ingen',
  'avce.common.close': 'Lukk',
  'avce.common.assess': 'Vurder',
  'avce.common.viewAssessment': 'Se vurdering',
  'avce.common.requestDocs': 'Be klienten om dokumentasjon',
  'avce.common.incomplete': 'Ikke komplett',
  'avce.common.notFetched': 'Hentes ikke av appen',
  'avce.common.details': 'Detaljer',
  'avce.common.warning': 'Varsel',
  'avce.common.voucher': 'Bilag',
  'avce.common.reset': 'Nullstill',
  'avce.common.all': 'Alle',
  'avce.common.ofCount': '{done} av {total}',
  'avce.common.documentation': 'Dokumentasjon',
  'avce.common.depreciation': 'Avskrivning',
  'avce.common.depreciations': 'Avskrivninger',
  'avce.common.reviewNeeded': 'Krever vurdering',
  'avce.common.notRelevant': 'Ikke relevant',
  'avce.common.matches': 'Stemmer',
  'avce.derived.possibleCapitalization': 'Mulige aktiveringspliktige kjøp er vurdert',
  'avce.derived.directPosting': 'Direkteføringer på anleggskonto er vurdert',
  'avce.derived.depreciationDiff': 'Avskrivningsdifferanser er behandlet',
  'avce.derived.noDepreciation': 'Eiendeler uten beregnet avskrivning er behandlet',
  'avce.derived.possibleDisposal': 'Mulige avganger er undersøkt',
  'avce.derived.registeredDisposal': 'Registrerte avganger er kontrollert',
  'avce.derived.gainLoss': 'Gevinst og tap ved avgang er kontrollert',
  'avce.derived.proceedsNotBooked': 'Vederlag som ikke er bokført er fulgt opp',
  'avce.derived.missingDocs': 'Manglende dokumentasjon er fulgt opp',
  'avce.derived.fullyDepreciated': 'Fullt avskrevne eiendeler er vurdert',
  'avce.derived.negativeValue': 'Negative bokførte verdier er behandlet',
  'avce.checklist.noPoints': 'Ingen kontrollpunkter er definert for eiendeler i denne perioden.',
  'avce.checklist.title': 'Faglig sjekkliste',
  'avce.checklist.titleReadOnly': 'Faglig sjekkliste (utførerens, skrivebeskyttet)',
  'avce.checklist.scope': 'Punktene gjelder hele eiendelsområdet. En avkryssing lagres på alle kontoene i området.',
  'avce.checklist.groupItems': 'Poster som krever behandling',
  'avce.checklist.handledOf': '{done} av {total} behandlet',
  'avce.checklist.notApplicable': 'Ikke aktuelt denne perioden',
  'avce.checklist.followsAssessments': 'Følger av vurderingene',
  'avce.checklist.groupAssessments': 'Overordnede faglige vurderinger',
  'avce.checklist.groupRelevance': 'Overordnet relevansvurdering',
  'avce.checklist.relevanceNote': 'Forhold bokføringen ikke ser. «Ikke relevant» er også et svar — det er ingen vurdering å gjøre hvis klienten verken leaser, har eiendeler hos tredjepart eller har stilt pant.',
  'avce.checklist.groupReady': 'Klarstilling',
  'avce.checklist.findingsHandled': '{total} kontrollfunn behandlet: {done} av {total}',
  'avce.checklist.manualProgress': '{done} av {total} manuelle kontrollpunkter fullført',
  'avce.checklist.manualProgressBy': 'Utføres av {name} · {done} av {total} manuelle kontrollpunkter fullført',
  'avce.blocker.findings': '{count} kontrollfunn er ikke ferdig vurdert',
  'avce.blocker.accounts': '{count} anleggskonto avviker fra registeret',
  'avce.blocker.docs': '{count} påkrevd dokumentasjon mangler',
  'avce.blocker.manualOne': '{count} manuelt kontrollpunkt gjenstår',
  'avce.blocker.manualMany': '{count} manuelle kontrollpunkter gjenstår',
  'avce.conclusion.title': 'Konklusjon og godkjenning',
  'avce.conclusion.label': 'Konklusjon',
  'avce.conclusion.placeholder': 'Hva viser gjennomgangen av eiendelene for denne perioden?',
  'avce.conclusion.savedAs': 'Lagres som begrunnelsen på kontrollpunktet «{label}».',
  'avce.conclusion.remainingRisk': 'Gjenstående risiko',
  'avce.conclusion.noRisk': 'Ingenting står igjen som hindrer at området sendes til kontroll. Avstemmingen sammenlikner to av foretakets egne kilder — fysisk eksistens, eierskap og verdifall er bekreftet manuelt, ikke av bokføringen.',
  'avce.conclusion.followUp': 'Oppfølging neste periode',
  'avce.conclusion.noFollowUp': 'Ingen vurderinger er merket for oppfølging neste periode.',
  'avce.conclusion.followedUp': 'Følges opp',
  'avce.conclusion.measure': 'Tiltak: {measure}',
  'avce.conclusion.noMeasure': 'Ingen tiltak notert',
  'avce.conclusion.deadline': ' · Frist {date}',
  'avce.conclusion.openAssessment': 'Åpne vurdering',
  'avce.conclusion.sendToReview': 'Send området til kontroll',
  'avce.conclusion.oneLeft': 'Én ting står igjen før området kan sendes.',
  'avce.conclusion.manyLeft': '{count} ting står igjen før området kan sendes.',
  'avce.drawer.note.capitalization': 'Vurder: har anskaffelsen en brukstid som gjør den aktiveringspliktig, er den ett driftsmiddel eller flere, og hører frakt og montering med i anskaffelseskosten?',
  'avce.drawer.note.depreciation': 'Vurder: er saldogruppen riktig, er avskrivningen bokført i riktig år, og er det indikasjoner på verdifall utover den ordinære avskrivningen?',
  'avce.drawer.note.documentation': 'Vurder: kan anskaffelseskosten dokumenteres, og hva skaffes hvor bilaget mangler?',
  'avce.drawer.note.disposal': 'Vurder: er eiendelen faktisk gått ut av virksomheten, er vederlaget bokført, og er gevinsten eller tapet — vederlag minus bokført verdi — riktig behandlet i resultatet? Skattemessig reduserer vederlaget saldogruppen i stedet, og de to skal ikke blandes.',
  'avce.drawer.note.directPosting': 'Vurder: skal posteringen stå på anleggskontoen, og skal den i så fall også inn i anleggsregisteret slik at den blir avskrevet?',
  'avce.drawer.note.lifetime': 'Vurder: eksisterer eiendelen fortsatt, brukes den, er restverdien rimelig, og bør den utrangeres og fjernes fra registeret?',
  'avce.drawer.assetInRegister': ' · Eiendel i registeret',
  'avce.drawer.assessment': 'Vurdering',
  'avce.drawer.reason': 'Faglig begrunnelse',
  'avce.drawer.reasonRequired': 'Faglig begrunnelse (påkrevd)',
  'avce.drawer.reasonPlaceholder': 'Hva gjelder forholdet, og hva bygger vurderingen på?',
  'avce.drawer.measure': 'Tiltak',
  'avce.drawer.measurePlaceholder': 'F.eks. Registrer eiendelen, korriger bilaget, eller be klienten om dokumentasjon',
  'avce.drawer.followUpDeadline': 'Frist for oppfølging',
  'avce.drawer.followUpNext': 'Følges opp neste periode',
  'avce.drawer.needsReason': 'Denne vurderingen krever en begrunnelse.',
  'avce.drawer.markDone': 'Marker ferdig vurdert',
  'avce.sources.title': 'Datakilder',
  'avce.sources.oneIncomplete': '{count} kilde er ikke komplett for perioden.',
  'avce.sources.manyIncomplete': '{count} kilder er ikke komplette for perioden.',
  'avce.sources.allPresent': 'Kildene avstemmingen leser er på plass for perioden.',
  'avce.sources.colSource': 'Kilde',
  'avce.sources.complete': 'Komplett',
  'avce.main.title': 'Automatisk hovedavstemming',
  'avce.main.noAccounts': 'Ingen anleggskonto å sammenlikne',
  'avce.main.differenceOpen': 'Differanse må behandles',
  'avce.main.matches': 'Anleggsregister og hovedbok stemmer samlet',
  'avce.main.ledgerValue': 'Bokført verdi i hovedboken',
  'avce.main.registerValue': 'Bokført verdi i anleggsregisteret',
  'avce.main.preliminaryDifference': 'Foreløpig differanse',
  'avce.main.notBookedDepreciation': 'Beregnet avskrivning som ikke er bokført ennå',
  'avce.main.explainedItems': 'Forklarte poster i avstemmingen',
  'avce.main.unexplainedDifference': 'Uforklart differanse',
  'avce.main.comparedOn': 'Sammenliknet på {accounts}.',
  'avce.main.explanation': 'Bokført verdi i hovedboken er anleggskontoene minus de akkumulerte avskrivningene. Saldoavstemmingen sammenlikner to av foretakets egne kilder — eiendelenes eksistens, klassifisering, avskrivning og dokumentasjon avgjøres av kontrollene under, ikke av at de to tallene er like.',
  'avce.main.cost': 'Anskaffelseskost',
  'avce.main.accumulated': 'Akkumulerte avskrivninger',
  'avce.main.bookValueRegister': 'Bokført verdi i registeret',
  'avce.main.activeAssets': 'Eiendeler i drift',
  'avce.main.yearDepreciation': 'Beregnet avskrivning {year}',
  'avce.main.additionsYtd': 'Tilganger hittil i {year}',
  'avce.main.disposalsPeriod': 'Avganger i perioden',
  'avce.main.itemsNeedAssessment': 'Forhold som krever vurdering',
  'avce.main.openRegister': 'Åpne anleggsregisteret',
  'avce.main.seeDepreciation': 'Se avskrivningene',
  'avce.main.seeControlAccounts': 'Se kontrollkontoene',
  'avce.accounts.notCompared': 'Ikke sammenliknet',
  'avce.accounts.title': 'Kontrollkontoer i hovedboken',
  'avce.accounts.none': 'Ingen anleggskonto finnes i denne perioden.',
  'avce.accounts.hint': 'Klikk en konto med eiendeler for å se hvilke eiendeler registeret har på den.',
  'avce.accounts.colAccount': 'Kontrollkonto',
  'avce.accounts.colOpening': 'Inngående saldo',
  'avce.accounts.colAdditions': 'Tilganger',
  'avce.accounts.colDisposals': 'Avganger',
  'avce.accounts.colClosing': 'Utgående saldo',
  'avce.accounts.colRegisterValue': 'Registerverdi',
  'avce.accounts.accumulatedNote': 'Akkumulerte avskrivninger. Registerets akkumulerte avskrivning inkluderer årets beregnede beløp, som først bokføres i årsoppgjøret — kontoen sammenliknes derfor ikke direkte.',
  'avce.accounts.costNote': 'Sammenliknes med anskaffelseskost i registeret',
  'avce.accounts.sumCost': 'Sum anskaffelseskost i anleggsregisteret',
  'avce.accounts.ledgerBalance': 'Hovedbokssaldo konto {code}',
  'avce.accounts.unexplained': 'Uforklart differanse — se anskaffelsene og direkteføringene',
  'avce.tile.possibleCapitalization': 'Mulige aktiveringspliktige kjøp',
  'avce.tile.depreciationDiff': 'Avskrivningsdifferanser',
  'avce.tile.missingDocs': 'Mangler dokumentasjon',
  'avce.tile.noDepreciation': 'Uten beregnet avskrivning',
  'avce.tile.fullyDepreciated': 'Fullt avskrevne eiendeler',
  'avce.tile.possibleDisposals': 'Mulige avganger uten registrering',
  'avce.tile.directPostings': 'Direkteføringer på anleggskonto',
  'avce.tile.negativeValues': 'Negative bokførte verdier',
  'avce.controlCard.title': 'Kontrollkort',
  'avce.controlCard.progress': '{checks} automatiske kontroller kjørt · manuelt vurdert {done} av {total}',
  'avce.controlCard.registerVsLedger': 'Anleggsregister mot hovedbok',
  'avce.controlCard.accountsCompared': '{count} kontoer sammenliknet',
  'avce.controlCard.activeFilter': 'Aktivt filter: {label} · {count} poster',
  'avce.checks.title': 'Automatiske kontroller',
  'avce.checks.note': 'Kontrollene krysser ikke av noe i den faglige sjekklista. De sier hva den som krysser av bør ha sett på. Verdifall, eierskap og fysisk eksistens kan ikke leses av bokføringen og ligger derfor blant de manuelle punktene.',
  'avce.checks.colCheck': 'Kontroll',
  'avce.checks.colRun': 'Kjøring',
  'avce.checks.colFindings': 'Funn',
  'avce.checks.run': 'Kjørt',
  'avce.checks.found': '{count} funn',
  'avce.checks.noFindings': 'Ingen funn',
  'avce.depr.notBookedYet': 'Ikke bokført ennå',
  'avce.assetStatus.active': 'I bruk',
  'avce.assetStatus.writtenOff': 'Fullt avskrevet',
  'avce.assetStatus.sold': 'Solgt',
  'avce.register.title': 'Anleggsregister',
  'avce.register.intro': 'Registeret er appens eget. Bokført avskrivning følger levetid og restverdi per eiendel; skattemessig saldo beregnes separat per gruppe.',
  'avce.register.note': 'Plumme beregner beløpet fra planen, men velger ikke levetid, restverdi eller om verdifall foreligger. De faglige valgene må dokumenteres, og manglende plan eller årlig verdifallsvurdering blir stående som avvik.',
  'avce.register.colAsset': 'Eiendel',
  'avce.register.colGroup': 'Saldogruppe',
  'avce.register.colAcquired': 'Anskaffet',
  'avce.register.colLife': 'Levetid',
  'avce.register.colDepreciation': 'Avskrivning {year}',
  'avce.register.colAccumulated': 'Akk. avskrivninger',
  'avce.register.colBookValue': 'Bokført verdi',
  'avce.register.years': '{years} år',
  'avce.register.empty': 'Ingen eiendeler passer med filtrene.',
  'avce.acq.title': 'Anskaffelser og aktiveringskontroll',
  'avce.acq.kpiAnalyzed': 'Kjøp analysert',
  'avce.acq.kpiOverThreshold': 'Over beløpsgrensen',
  'avce.acq.kpiCapitalized': 'Aktivert i perioden',
  'avce.acq.kpiDirect': 'Direkteført på anleggskonto',
  'avce.acq.noThreshold': 'Beløpsgrensen for aktivering er en norsk skatteregel. Regnskapslandet er {country}, og Plumme har ingen tilsvarende terskel å kontrollere mot her.',
  'avce.acq.threshold': 'Beløpsgrensen er {amount} med minst {years} års brukstid, og gjelder ETT driftsmiddel — ikke fakturasummen. Den er et kontrollsignal: Plumme avgjør ikke at et kjøp skal aktiveres, og et mindre kjøp kan være aktiveringspliktig hvis brukstiden er lang nok.',
  'avce.acq.colSupplier': 'Leverandør',
  'avce.acq.colDescription': 'Beskrivelse',
  'avce.acq.colDeductibleVat': 'Fradragsberettiget MVA',
  'avce.acq.colTreatment': 'Behandling',
  'avce.acq.capitalized': 'Aktivert',
  'avce.acq.expensed': 'Kostnadsført',
  'avce.acq.empty': 'Ingen kjøp i perioden er store nok til å kontrolleres mot grensen.',
  'avce.depr.kpiBookedYtd': 'Bokført hittil i året',
  'avce.depr.kpiDeviatingGroups': 'Saldogrupper med avvik',
  'avce.depr.kpiWithoutPlan': 'Eiendeler uten beregnet avskrivning',
  'avce.depr.note': 'Avskrivningen bokføres i årsoppgjøret, ikke månedlig. En differanse tidlig i året betyr derfor som regel bare at året ikke er avsluttet — den er et kontrollpunkt, ikke et avvik i seg selv.',
  'avce.depr.colRate': 'Sats',
  'avce.depr.colAssets': 'Eiendeler',
  'avce.depr.colExpenseAccount': 'Kostnadskonto',
  'avce.depr.colCalculated': 'Beregnet avskrivning',
  'avce.depr.colBooked': 'Bokført avskrivning',
  'avce.depr.empty': 'Ingen saldogrupper med eiendeler eller bokført avskrivning.',
  'avce.disposals.title': 'Salg og utrangering',
  'avce.disposals.kpiRegistered': 'Registrerte avganger',
  'avce.disposals.kpiUnregistered': 'Mulige uregistrerte avganger',
  'avce.disposals.kpiGainReview': 'Gevinst/tap til kontroll',
  'avce.disposals.kpiNoVoucher': 'Registrerte avganger uten bilag',
  'avce.disposals.registerProceeds': 'Vederlag i anleggsregisteret',
  'avce.disposals.bookedProceeds': 'Bokført salgssum på {accounts}',
  'avce.disposals.computedGain': 'Beregnet gevinst/tap (register)',
  'avce.disposals.bookedNet': 'Bokført netto på avgangskontoene',
  'avce.disposals.note': 'Gevinsten er vederlaget minus bokført verdi ved avgangen. Er avskrivningen ikke bokført, bærer motkontoen hele anskaffelseskosten, og bokført netto blir lavere enn den beregnede gevinsten — differansen er da de samme avskrivningene som står som egen linje i hovedavstemmingen. Skattemessig behandles avgangen i saldogruppen, ikke som en gevinst.',
  'avce.disposals.colAssetOrPosting': 'Eiendel eller postering',
  'avce.disposals.colProceeds': 'Vederlag',
  'avce.disposals.colBookValueAtDisposal': 'Bokført verdi ved avgang',
  'avce.disposals.colGain': 'Beregnet gevinst/tap',
  'avce.disposals.voucherNo': 'Bilag {number}',
  'avce.disposals.registeredInPeriod': 'Registrert i perioden',
  'avce.disposals.empty': 'Ingen avganger eller kreditføringer på anleggskontoene i perioden.',
  'avce.flag.possibleCapitalization': 'Mulig aktiveringspliktig kjøp',
  'avce.flag.directPosting': 'Direkteføring på anleggskonto',
  'avce.flag.depreciationDiff': 'Avskrivningsdifferanse',
  'avce.flag.noDepreciation': 'Ingen avskrivning beregnet',
  'avce.flag.missingBookPlan': 'Mangler regnskapsmessig avskrivningsplan',
  'avce.flag.missingImpairment': 'Mangler årlig verdifallsvurdering',
  'avce.flag.fullyDepreciated': 'Fullt avskrevet — fortsatt i registeret',
  'avce.flag.possibleDisposal': 'Mulig avgang ikke registrert',
  'avce.flag.disposalRegistered': 'Avgang registrert i perioden',
  'avce.flag.negativeValue': 'Negativ bokført verdi',
  'avce.flag.gainReview': 'Gevinst/tap krever kontroll',
  'avce.flag.proceedsNotBooked': 'Vederlag ikke bokført',
  'avce.assess.notAssessed': 'Ikke vurdert',
  'avce.assess.noCorrection': 'Ingen korrigering nødvendig',
  'avce.assess.capitalize': 'Skal aktiveres i anleggsregisteret',
  'avce.assess.correctlyExpensed': 'Korrekt kostnadsført',
  'avce.assess.correctAccount': 'Korrigeres — føres på riktig konto',
  'avce.assess.depreciationCorrected': 'Avskrivning korrigeres',
  'avce.assess.depreciationAccepted': 'Avvik i avskrivning akseptert',
  'avce.assess.registerDisposal': 'Avgang registreres i anleggsregisteret',
  'avce.assess.notDisposal': 'Ikke en avgang',
  'avce.assess.lifetimeConfirmed': 'Fortsatt i bruk — levetid vurdert',
  'avce.assess.retire': 'Utrangeres — fjernes fra registeret',
  'avce.assess.gainConfirmed': 'Gevinst/tap kontrollert og korrekt',
  'avce.assess.bookProceeds': 'Vederlag skal bokføres',
  'avce.assess.impairmentAssessed': 'Verdifall vurdert',
  'avce.assess.awaitingDocs': 'Avventer dokumentasjon',
  'avce.assess.awaitingClient': 'Avventer klienten',
  'avce.type.capitalization': 'Aktivering',
  'avce.type.disposal': 'Avgang',
  'avce.type.directPosting': 'Direkteføring',
  'avce.type.lifetime': 'Levetid og bruk',
  'avce.quick.done': 'Ferdig vurdert',
  'avce.quick.newInPeriod': 'Ny i perioden',
  'avce.quick.noDocs': 'Uten dokumentasjon',
  'avce.quick.disposalInPeriod': 'Avgang i perioden',
  'avce.flags.more': '+{count} flere',
  'avce.items.intro': 'Postene er samlet fra anleggsregisteret, anskaffelsene, avskrivningene, avgangene og posteringene på anleggskontoene. Vurderingen lagres på avstemmingskontoen og leses av kontrolløren.',
  'avce.items.clearFilters': 'Nullstill filtre',
  'avce.items.colReference': 'Referanse',
  'avce.items.colAssessmentStatus': 'Vurderingsstatus',
  'avce.items.empty': 'Ingen forhold passer med filtrene.',
  'avce.docs.colBasis': 'Grunnlag',
  'avce.docs.inPlace': 'På plass',
  'avce.docs.attached': 'Vedlagt dokumentasjon',
  'avce.docs.empty': 'Ingen dokumenter er lastet opp på eiendelsområdet for denne perioden.',
  'avce.docs.emptyWithUpload': 'Ingen dokumenter er lastet opp på eiendelsområdet for denne perioden. Bruk dokumentfanen i høyrepanelet for å legge dem ved.',
  'avce.page.noAccount': 'Eiendelsområdet har ingen avstemmingskonto i denne perioden.',
  'avce.nav.overview': 'Oversikt',
  'avce.nav.countDifference': '{count} differanse',
  'avce.nav.fixedAssets': 'Anleggsmidler',
  'avce.nav.countRegistered': '{count} registrert',
  'avce.nav.acquisitions': 'Anskaffelser',
  'avce.nav.countToAssess': '{count} til vurdering',
  'avce.nav.countPurchases': '{count} kjøp',
  'avce.nav.countFindings': '{count} funn',
  'avce.nav.controlAccounts': 'Kontrollkontoer',
  'avce.nav.countMatching': '{matching}/{total} stemmer',
  'avce.nav.deviationsActions': 'Avvik og tiltak',
  'avce.nav.countMissing': '{count} mangler',
  'avce.nav.controlApproval': 'Kontroll og godkjenning',
  'avce.page.assets': 'Eiendeler',
  'avce.page.hintOpen': '{count} forhold med varsel er ikke ferdig vurdert.',
  'avce.page.hintDone': 'Alle forhold med varsel er vurdert.',
  'avce.page.title': 'Eiendeler — anleggsregister, hovedbok og avskrivninger',
  'avce.page.responsible': ' · Ansvarlig {name}',
  'avce.page.threshold': ' · Beløpsgrense for aktivering {amount}',
  'avce.page.itemsNeedAssessment': '{count} forhold krever vurdering',
  'avce.page.noOpenItems': 'Ingen åpne forhold',
  'avce.page.intro': 'Avstemmingen sammenlikner anleggsregisteret med hovedboken og leter etter det som aldri kom inn i registeret.',
  'avce.page.noItemsFlagged': 'Ingen forhold er flagget for denne perioden.',
  'avce.page.itemsFlagged': '{total} forhold er flagget, og {open} av dem krever fortsatt en vurdering.',
  'avce.page.method': 'Avskrivningsmetode',
  'avce.page.methodValue': 'Saldoavskrivning per saldogruppe',
  'avce.page.hasFixedAssets': 'Foretaket har anleggsmidler',
  'avce.page.noneInRegister': 'Ingen i registeret',
  'avce.page.yes': 'Ja',
  'avce.page.country': 'Regnskapsland',
  'avce.page.readThrough': 'Grunnlag lest til og med',
  'avce.page.noExternalBalance': 'Eiendeler har ingen ekstern saldo. Både anleggsregisteret og hovedboken er foretakets egne kilder, og en eiendel som aldri ble registrert mangler i begge. Fysisk eksistens, eierskap, pant og verdifall bekreftes derfor manuelt i sjekklista — ikke av at de to tallene er like.',
  'avce.page.registerEmpty': 'Anleggsregisteret er tomt for {year}. Det gjør ikke området «ikke relevant»: kontrollene under ser fortsatt etter større kostnadsførte kjøp, posteringer på anleggskontoene og eiendeler fra tidligere perioder. Er området faktisk ikke relevant, settes det med begrunnelse i relevansvurderingen i sjekklista.',
});
